<div>
  <button
    data-dd-action-name="pricing-package-actions.update-plan-button"
    class="btn btn-primary w-100"
    type="button"
    authorizeEnable
    [authorizeOrganisation]="OrganisationPermissionType.UpdateSubscription"
    (click)="onUpdatePackage()"
    [disabled]="isUpdating || isCurrentPackage || isPriceOnApplication"
  >
    <i-lucide [name]="icon"></i-lucide>
    {{ actionLabel }}
  </button>
</div>
